export enum HttpStatus {
  BadRequest = 400,
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404
}

export const isSuccess = (status: number) => status >= 200 && status < 300;
export const isBadRequest = (status: number) => status === HttpStatus.BadRequest;
export const isUnauthorized = (status: number) => status === HttpStatus.Unauthorized;
export const isForbidden = (status: number) => status === HttpStatus.Forbidden;
export const isNotFound = (status: number) => status === HttpStatus.NotFound;
